import PropTypes from 'prop-types'
import { Stack } from '@mui/material';
import { useTranslation } from 'react-i18next';

import TextField from 'components/TextField';

export default function FormStepLocation({ values, handleChange }) {
  const { t } = useTranslation('common');

  return (
    <Stack spacing={3}>
      <TextField
        multiline
        name="location"
        label={t('myProfile.location')}
        value={values.location}
        onChange={handleChange}
      />
    </Stack>
  );
}

FormStepLocation.propTypes = {
  values: PropTypes.object,
  handleChange: PropTypes.func
}
